import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonDays,
  ButtonStyled,
  ButtonStyledTb,
  FormButtonStyled,
  FormEleWrapper,
  HeadingStyled,
  LabelStyled,
  SubHeadingStyled,
  TextStyled,
} from "../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import FloatingInput from "../../../components/common/inputFields/FloatingInput";
import { Camera, ProfileImgLarge } from "../../../components/styled/AllImages";
import { ProfileEditContainer } from "./styled";
import { Col, Form, Row } from "react-bootstrap";
import CustomRadioButton from "../../../components/common/radioButtons/CustomRadio";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { SelectionDropdown } from "../../../components/styled/FormElements";
import { TimeListFrom, TimeListTo } from "../../../helpers/dummyConstants";
import PhoneInputField from "../../../components/common/inputFields/PhoneInput";
import { useForm } from "react-hook-form";
import { emailRegex } from "../../../utils";
import ProfileApi from "../../../services/api/profileApi";
import { toast } from "react-toastify";
import { useUser } from "../../../context/userContext";
import { useNavigate } from "react-router-dom";

const ContactInformation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fetchUserInfo, user } = useUser();
  const {
    register,
    reset,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (formData) => {
    try {
      setLoading(true);
      const { code, message } = await ProfileApi.saveContactDetail(formData);
      if (code === 200) {
        toast.success(t("contact_information_updated"));
        fetchUserInfo();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (user) {
      reset({
        contact_phone: user?.contact_detail?.contact_phone || "",
        contact_office_phone: user?.contact_detail?.contact_office_phone || "",
        contact_email: user?.contact_detail?.contact_email || "",
      });
    }
  }, [user]);
  return (
    <>
      <ProfileEditContainer>
        <HeadingStyled size="24px" className="editProfileHeading">
          {t("ContactDetails")}
        </HeadingStyled>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box className="profileFormContainerInner">
            <Row className="mt-3">
              <Col md={12}>
                <PhoneInputField
                  name="contact_phone"
                  label={"cell_phone"}
                  placeholder="cell_phone"
                  register={register}
                  control={control}
                  staric={"staric"}
                  validationRules={{
                    required: true,
                  }}
                  className={"flex-wrap p-0"}
                />
              </Col>
              <Col md={12}>
                <PhoneInputField
                  name="contact_office_phone"
                  label="OfficePhone"
                  placeholder="OfficePhone"
                  register={register}
                  control={control}
                  validationRules={{
                    required: false,
                  }}
                />
              </Col>
              <Col md={12}>
                <ValidatedInput
                  name="contact_email"
                  type="input"
                  fieldType="text"
                  placeholder="Email"
                  label="Email"
                  staric={"staric"}
                  className=""
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: true,
                    pattern: {
                      value: emailRegex,
                      message: "invalidEmail",
                    },
                  }}
                />
              </Col>
            </Row>
            <Box className="formBtns">
              <ButtonStyledTb
                className="nextStepBtn"
                type="button"
                bg="var(--white)"
                border="var(--border)"
                color="var(--darkGrey)"
                onClick={() => navigate("/my-profile")}
              >
                {t("Cancel")}
              </ButtonStyledTb>
              <FormButtonStyled
                type="submit"
                bg="var(--themeColorSecondary)"
                disabled={loading}
                isLoading={loading}
                label={t("Update")}
              />
            </Box>
          </Box>
        </Form>
      </ProfileEditContainer>
    </>
  );
};

export default ContactInformation;
